export default defineNuxtPlugin({
  name: 'auth',
  dependsOn: [
    'nuxt:global-components',
    'nuxt:router',
    'nuxt-site-config:init'
  ],
  parallel: true,
  enforce: 'pre',
  async setup(nuxtApp: any) {
    const user = computed<IAuth>(() => {
      const value = new Auth(useSanctumUser<IUser>()?.value ?? useState(useRuntimeConfig()?.public?.sanctum?.userStateKey)?.value);
      if (! value?.logged())
        value?.refresh();
      return value;
    });
    const refresh = async function (): Promise<IAuth> {
      const value = await user;
      if (! value?.value?.logged())
        await value?.value?.refresh();
      return value?.value;
    }
    const call = async function (): Promise<boolean> {
      const nuxtApp = useNuxtApp();
      let auth = null;
      try {
        auth = await refresh(); // the Vue/Nuxt compiler loses context here because of the try/catch block.
      } catch (e) {
        auth = null;
      }
      if (! auth) // apply the correct Nuxt context to our `navigateTo` call.
        return nuxtApp.runWithContext(() => navigateTo(useSanctumConfig?.redirect?.onAuthOnly ?? '/'));
      return auth?.logged();
    }
    addRouteMiddleware('session', async (to: any, from: any) => await call());
    addRouteMiddleware('permission', async (to: any, from: any) => {
      const resp = await call();
      if (resp !== true)
        return resp;
      const auth = await refresh();
      return auth?.routeAvailable(to, false);
    });
    addRouteMiddleware('api-permission', async (to: any, from: any) => {
      const resp = await call();
      if (resp !== true)
        return resp;
      const auth = await refresh();
      return auth?.routeAvailable(to, true);
    });
    // await useSanctumAuth().init();
    // this is the equivalent of a normal functional plugin
    await nuxtApp.vueApp?.use({
      install(app: any, options: any) {
        app.provide('auth', user as ComputedRef<IAuth>);
      },
    });

    // Login check
    let intervalId = undefined as undefined | number;
    nuxtApp.hook('app:mounted', () => {
      if (process.client)
        intervalId = setInterval(async () => (await user?.value?.refresh()), (1000 * 60 * 1));
    });
    nuxtApp.hook('app:unmounted', () => {
      if (process.client)
        clearInterval(intervalId);
    });

    return {
      provide: {
        auth: user as ComputedRef<IAuth>
      }
    };
  },
  env: {
    islands: true
  }
});
